import { usePermissions } from "@/features/auth/store/usePermissions.store";

import { useLoadingCooperatives } from "./hooks/useLoadingCooperatives";
import { useMenu } from "./menuConfig/useMenu";

export const useNamekRouter = () => {
  const isSignedIn = usePermissions((state) => state.isSignedIn);
  const menuItems = useMenu();

  const { isLoading } = useLoadingCooperatives();

  const hasEmptyPermission = menuItems.length === 0;

  return {
    isLoading,
    hasEmptyPermission,
    isSignedIn,
  };
};
